import { TextField, TextFieldProps } from "@mui/material"
import { useThemeContext } from "../../theme/ThemeContext"

export const ISTextField: React.FC<TextFieldProps> = (props) => {
  const { theme } = useThemeContext()
  return <TextField
    sx={{
      "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: theme.palette.action.disabled
      },
      "& .MuiFormLabel-root.Mui-disabled": {
        color: theme.palette.action.disabled,
      }
    }}
    margin="normal"
    fullWidth
    {...props}
  />
}
